import React from 'react'
import { TimerMode } from './types'
import { ActivityState } from '@/redux/slices/timerConfigurationSlice'
import { TimerDisplay } from './TimerDisplay'

interface TimerCurrentStatusSectionProps {
  status: {
    mode: string
    currentRound: number
    totalRounds: number
    currentPhase: string
    timeRemaining: number
  }
  mode: TimerMode
  endTime: string | null
  phaseStatus: ActivityState | null
  roundStatus: ActivityState | null
  isInfinitePhase: boolean
}

export const TimerCurrentStatusSection: React.FC<
  TimerCurrentStatusSectionProps
> = ({
  status,
  mode,
  endTime,
  phaseStatus,
  roundStatus,
  isInfinitePhase,
}) => {
  return (
    <div>
      <h3 className='mb-4 text-lg font-medium text-dark-blue'>Current Status</h3>
      <div className='space-y-4'>
        <div className='grid grid-cols-[100px_1fr] gap-2'>
          <span className='font-medium text-dark-blue'>Mode:</span>
          <span className='inline-block px-3 py-1 rounded-md bg-slate-100'>
            {status.mode}
          </span>
        </div>

        <div className='grid grid-cols-[100px_1fr] gap-2'>
          <span className='font-medium text-dark-blue'>Round:</span>
          <span className='inline-block px-3 py-1 rounded-md bg-slate-100 w-fit'>
            {status.currentRound} / {status.totalRounds}
          </span>
        </div>

        {mode !== TimerMode.MANUAL_MODE && (
          <div className='space-y-4'>
            <div className='grid grid-cols-[100px_1fr] gap-2'>
              <span className='font-medium text-dark-blue'>Phase:</span>
              <span className='inline-block px-3 py-1 rounded-md bg-slate-100 w-fit'>
                {status.currentPhase}
              </span>
            </div>

            <div className='grid grid-cols-[100px_1fr] gap-2'>
              <span className='font-medium text-dark-blue'>Time left:</span>
              <span className='inline-block px-3 py-1 rounded-md bg-slate-100 w-fit'>
                <TimerDisplay
                  roundStatus={roundStatus}
                  isInfinitePhase={isInfinitePhase}
                  endTime={endTime}
                  phaseStatus={phaseStatus}
                />
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
